import httpService from './http.service';

function runDailyCron() {
  return httpService.post('/crons/daily');
}

export default {
  runDailyCron
};
